var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

import React, { Component } from "react";
import { connect } from "react-redux";

import SectionContainer from "../../../components/Library/SectionContainer";
import { getEvents } from "../../actions/events";

import styles from "./UpcomingEvents.css";

var UpcomingEvents = function (_Component) {
  _inherits(UpcomingEvents, _Component);

  function UpcomingEvents() {
    _classCallCheck(this, UpcomingEvents);

    return _possibleConstructorReturn(this, (UpcomingEvents.__proto__ || Object.getPrototypeOf(UpcomingEvents)).apply(this, arguments));
  }

  _createClass(UpcomingEvents, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.props.getEvents();
    }
  }, {
    key: "render",
    value: function render() {
      var events = this.props.events;

      if (!events.results.length) return null;

      return React.createElement(
        SectionContainer,
        { header: "Upcoming Events", className: styles.root },
        events.results.map(function (event, index) {
          return React.createElement(
            "div",
            { key: event.title + "-" + index },
            React.createElement(
              "div",
              { className: styles.event },
              event.artwork_url && React.createElement(
                "a",
                { target: "_blank", href: event.rsvp_link },
                React.createElement("img", { className: styles.image, src: event.artwork_url, alt: event.title })
              ),
              React.createElement(
                "div",
                null,
                React.createElement(
                  "a",
                  { target: "_blank", href: event.rsvp_link, className: styles.headline },
                  event.title
                ),
                React.createElement(
                  "div",
                  { className: styles.date },
                  event.date
                ),
                React.createElement(
                  "div",
                  { className: styles.description },
                  event.description
                )
              )
            ),
            events.results.length - 1 !== index && React.createElement("hr", { className: styles.separator, "aria-hidden": true })
          );
        })
      );
    }
  }]);

  return UpcomingEvents;
}(Component);

var mapStateToProps = function mapStateToProps(state) {
  return {
    events: state.upcomingEvents
  };
};

var mapDispatchToProps = {
  getEvents: getEvents
};

export default connect(mapStateToProps, mapDispatchToProps)(UpcomingEvents);


// WEBPACK FOOTER //
// ./src/events/components/UpcomingEvents/UpcomingEvents.js